import * as Sentry from "@sentry/browser";

import { makeRequest } from "../util";

export function handleSaveEvent(eventDef) {
  return makeRequest<{ error_message: string }>("save_event_def", eventDef)
    .then((resp) => {
      if (resp.data.error_message) {
        throw new Error(resp.data.error_message);
      }

      return {
        ...eventDef,
        updated_at: new Date().toISOString(),
      };
    })
    .catch((error) => {
      Sentry.captureException(error);
      console.log(error);
    });
}

export function handleToggleDestinations(
  destinationId: string,
  eventIds: string[],
  state: boolean
) {
  return makeRequest<any>("bulk_toggle_destination", {
    dest_id: destinationId,
    event_def_ids: eventIds,
    state,
  }).then((resp) => {
    if (resp.data.error_message) {
      throw new Error(resp.data.error_message);
    }

    return resp;
  });
}

export function handleToggleDestination(
  eventId: string,
  destID: string,
  state: boolean
) {
  return makeRequest<{ error_message: string }>("toggle_destination", {
    dest_id: destID,
    event_def_id: eventId,
    state,
  }).then((resp) => {
    if (resp.data.error_message) {
      throw new Error(resp.data.error_message);
    }

    return resp;
  });
}
